const FeesSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">💰 Quản Lý Học Phí</h2>
            <p className="text-slate-700">
                Theo dõi và thanh toán học phí một cách dễ dàng.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Tính năng chính:</h3>
                <div className="space-y-4">
                    <div className="p-4 border-l-4 border-blue-500 bg-blue-50">
                        <h4 className="font-semibold text-blue-900">📊 Theo dõi học phí</h4>
                        <p className="text-sm text-slate-700">
                            Xem tổng quan học phí đã nộp và còn nợ. Hệ thống hiển thị trạng thái:
                            <strong className="text-green-600"> Đã thanh toán</strong>,
                            <strong className="text-blue-600"> Thanh toán một phần</strong>,
                            <strong className="text-yellow-600"> Chưa thanh toán</strong>, hoặc
                            <strong className="text-red-600"> Quá hạn</strong>
                        </p>
                    </div>
                    <div className="p-4 border-l-4 border-green-500 bg-green-50">
                        <h4 className="font-semibold text-green-900">📱 Thanh toán QR Code</h4>
                        <ol className="text-sm text-slate-700 space-y-2 mt-2">
                            <li>1. Nhấn nút <strong>"Thanh toán"</strong> ở khoản học phí cần nộp</li>
                            <li>2. Nhập số tiền muốn thanh toán (có thể trả một phần)</li>
                            <li>3. Nhấn <strong>"Tạo QR"</strong> để tạo mã QR Code</li>
                            <li>4. Mở app ngân hàng và quét mã QR</li>
                            <li>5. Xác nhận thanh toán trên app ngân hàng</li>
                            <li>6. Chờ admin xác nhận thanh toán (thường ít hơn 24h)</li>
                        </ol>
                    </div>
                    <div className="p-4 border-l-4 border-purple-500 bg-purple-50">
                        <h4 className="font-semibold text-purple-900">💳 Thanh toán linh hoạt</h4>
                        <p className="text-sm text-slate-700">
                            Bạn có thể thanh toán một phần số tiền học phí. Ví dụ: học phí 3,000,000đ,
                            bạn có thể trả 1,500,000đ trước, số còn lại 1,500,000đ sẽ được cập nhật tự động.
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
                <h3 className="text-lg font-semibold text-yellow-900 mb-2">⚠️ Lưu ý quan trọng</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• Số tiền thanh toán không được vượt quá số tiền còn nợ</li>
                    <li>• QR Code chứa đầy đủ thông tin: số tài khoản, số tiền, nội dung chuyển khoản</li>
                    <li>• Sau khi chuyển khoản, admin sẽ xác nhận trong vòng 24 giờ</li>
                    <li>• Nếu sau 24h chưa được xác nhận, vui lòng liên hệ giáo viên</li>
                </ul>
            </div>
        </div>
    );
};

export default FeesSection;
